angular.module('client-feature')
    .component('clientFeatureList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/client-feature/list.html',
        controller: function ($scope, $state, ClientFeatureService, ClientFeatureConst) {
            this.reset = () => this.filters = {}
            this.ClientFeatureService = ClientFeatureService
            $scope.$on(ClientFeatureConst.eventUpdate, () => $state.reload())
        }
    })
